export const checkoutAttemptStatuses = {
  processing: "processing",
  waiting_for_confirmation: "waiting_for_confirmation",
  delayed_confirmation: "delayed_confirmation",
  completed: "completed",
  canceled: "canceled",
  failed: "failed",
} as const;
export type CheckoutAttemptStatus =
  (typeof checkoutAttemptStatuses)[keyof typeof checkoutAttemptStatuses];
